/* صفحة المنتج: المعرض، الكمية، تبديل الحجم، الشريط الثابت */
(function(){
  var img   = document.getElementById('gal-img');
  var thumbs= document.querySelectorAll('.gal-thumbs button');
  var qDec  = document.getElementById('q-dec');
  var qInc  = document.getElementById('q-inc');
  var qVal  = document.getElementById('q-val');
  var qIn   = document.getElementById('q-input');
  var vid   = document.getElementById('pdp-vid');
  var form  = document.getElementById('product-form');
  var bar   = document.getElementById('pdp-bar');
  var barAdd= document.getElementById('bar-add');
  var barPr = document.getElementById('bar-price');
  var qty = 1;

  thumbs.forEach(function(b){
    b.addEventListener('click', function(){
      if (img) img.src = b.dataset.src;
      thumbs.forEach(function(x){ x.setAttribute('aria-current', String(x === b)); });
    });
  });

  if (qDec) qDec.onclick = function(){ if (qty > 1){ qty--; qVal.textContent = qty; if (qIn) qIn.value = qty; } };
  if (qInc) qInc.onclick = function(){ if (qty < 20){ qty++; qVal.textContent = qty; if (qIn) qIn.value = qty; } };

  document.querySelectorAll('.size-btn').forEach(function(b){
    b.addEventListener('click', function(){
      if (b.disabled) return;
      document.querySelectorAll('.size-btn').forEach(function(x){ x.setAttribute('aria-pressed', String(x === b)); });
      if (vid) vid.value = b.dataset.vid;
      if (barAdd) barAdd.dataset.bag = b.dataset.vid;
      var now = document.querySelector('.price-now');
      if (now) now.textContent = b.dataset.price;
      if (barPr) barPr.textContent = b.dataset.price;
      var url = new URL(window.location);
      url.searchParams.set('variant', b.dataset.vid);
      history.replaceState({}, '', url);
      if (window.applyLang && window.currentLang) window.applyLang(window.currentLang());
    });
  });

  /* الإضافة عبر السلة الجانبية بدل إعادة تحميل الصفحة */
  if (form) form.addEventListener('submit', function(e){
    e.preventDefault();
    var id = vid ? parseInt(vid.value, 10) : null;
    if (!id) return;
    fetch(window.ARAB.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
    }).then(function(){
      if (window.arabCartRefresh) window.arabCartRefresh();
      var open = document.getElementById('cart-open');
      if (open) open.click();
    });
  });

  /* الشريط الثابت يظهر لما يختفي زر الشراء الأساسي */
  try {
    var main = form ? form.querySelector('button[type="submit"]') : null;
    if (main && typeof IntersectionObserver === 'function'){
      new IntersectionObserver(function(es){
        es.forEach(function(e){ bar.classList.toggle('show', !e.isIntersecting); });
      }, { rootMargin: '0px 0px -80px 0px' }).observe(main);
    }
  } catch(e){}
})();
